/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip amount, total and split per person`)
};

const es_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe de la propina, total y reparto por persona`)
};

const de_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trinkgeldbetrag, Gesamtbetrag und Aufteilung pro Person`)
};

const nl_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fooibedrag, totaal en verdeling per persoon`)
};

const fr_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant du pourboire, total et répartition par personne`)
};

const it_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo della mancia, totale e quota a persona`)
};

const pt_br2_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor da gorjeta, total e divisão por pessoa`)
};

const pt_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor da gorjeta, total e divisão por pessoa`)
};

const ja_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップ額、合計、一人当たりの金額`)
};

const zh_pct_nav_tip_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小费金额、总额及人均分摊`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_tip_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_tip_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_tip_desc", locale)
	if (locale === "en") return en_pct_nav_tip_desc(inputs)
	if (locale === "es") return es_pct_nav_tip_desc(inputs)
	if (locale === "de") return de_pct_nav_tip_desc(inputs)
	if (locale === "nl") return nl_pct_nav_tip_desc(inputs)
	if (locale === "fr") return fr_pct_nav_tip_desc(inputs)
	if (locale === "it") return it_pct_nav_tip_desc(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_tip_desc(inputs)
	if (locale === "pt") return pt_pct_nav_tip_desc(inputs)
	if (locale === "ja") return ja_pct_nav_tip_desc(inputs)
	return zh_pct_nav_tip_desc(inputs)
};